import { render, staticRenderFns } from "./workben_works.vue?vue&type=template&id=55ef07be&scoped=true&"
import script from "./workben_works.vue?vue&type=script&lang=js&"
export * from "./workben_works.vue?vue&type=script&lang=js&"
import style0 from "./workben_works.vue?vue&type=style&index=0&id=55ef07be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ef07be",
  null
  
)

export default component.exports